import { TwinDictionary } from '../../globals/dictionary'
import useTwinTranslation from '../useTwinTranslation'

const useProductActiveDictionary = () => {
    const { t } = useTwinTranslation()
    const productActiveDict: TwinDictionary = {
        'true': { name: t('actived', 'Activados') },
        'false': { name: t('disabled', 'Desactivados') },
        'all': { name: t('all', 'Todos') }
    }
  
    return { productActiveDict }
}

export default useProductActiveDictionary